import ServiceTypes from '../constants/ServiceTypes';

// This guy will return you a service type with a key value and graystone code, pass in the value which is also in a constants enum file
const serviceTypes = [
  {key: 'Funeral', value: ServiceTypes.FUNERAL, graystoneCode: 'U', route: 'funeral'},
  {key: 'Cremation', value: ServiceTypes.CREMATION, graystoneCode: 'C', route: 'cremation'},
  {key: 'Cemetery', value: ServiceTypes.CEMETARY, graystoneCode: 'D', route: 'cemetery'},
  {key: 'Monument', value: ServiceTypes.MONUMENT, graystoneCode: 'E', route: 'monument'},
  {key: 'PreNeed', value: ServiceTypes.PRE_NEED, graystoneCode: 'F', route: 'preneed'},
  {key: 'Pet Cremation', value: ServiceTypes.PET_CREMATION, graystoneCode: 'G', route: 'pet-cremation'},
  {key: 'Event Planning', value: ServiceTypes.EVENT_PLANNING, graystoneCode: 'H', route: 'event-planning'},
];

const getServiceType = value => {
  return serviceTypes.find(service => service.value === value);
};

const getBitwiseTypes = code => {
  const result = [];
  let itemId = 1;

  while (code > 0) {
    if (code & 1) {
      result.push(itemId);
    }

    itemId <<= 1;
    code >>= 1;
  }

  return result;
};

const getServiceTypeByCode = code => {
  return serviceTypes.find(service => service.graystoneCode === code);
};
const getCodeByKey = key => {
  if (!isNaN(key)) {
    return serviceTypes.find(service => service.value === parseInt(key)).graystoneCode;
  } else {
    return 'U';
  }
};

const getValueByCode = code => {
  if (!code) return ServiceTypes.FUNERAL;
  else {
    return serviceTypes.find(service => service.graystoneCode === code).value;
  }
};
const getServiceTypes = filters => {
  if (!filters) return serviceTypes;

  return serviceTypes.filter(service => filters.includes(service.key));
};

export {getServiceType, getValueByCode, getBitwiseTypes, getServiceTypes, getServiceTypeByCode, getCodeByKey};
